import React, { useEffect, useMemo, useState } from "react";

import ProductInTableContent from "./ProductInTableContent";

// -------------------------------------------------------------
const ProductInTable = ({ article: trueArticle, articule, id, ...rest }) => {
  const { text, name, dateRange: defaultDateRange } = rest;
  // Нужно для того чтобы не передавать каждый раз dateRange, а получать его из url автоматом
  const dateRange = useMemo(() => {
    if (defaultDateRange) return defaultDateRange;
    const searchParams = new URLSearchParams(window.location.search);
    const dateFrom = searchParams.get("date_from");
    const dateTo = searchParams.get("date_to");
    if (dateFrom && dateTo) return [new Date(dateFrom), new Date(dateTo)];
  }, [defaultDateRange, window.location.search]);
  // Подобная двойственность связана с тем, что кто-то ошибся в английском написании
  // артикула, а потом кто-то решил поправить, теперь одно и то же свойство принимается под
  // разными переменными, тут я их объединил
  const article = trueArticle || articule || id;
  if (!article) return "Товар не найден";
  const correctText = text || name;
  if (!correctText || !rest.image) return article;
  return <ProductInTableContent {...{ ...rest, article, text: correctText, dateRange }} />;
};

export default ProductInTable;
